import React from 'react';

const { isSandals } = window._app.brandOptions;

const sandalsOptions = [
  {
    title: 'Resort Name',
    key: 'resortName',
    type: 'string',
  },
  {
    title: 'Resort Location',
    key: 'resortLocation',
    type: 'string',
  },
  {
    title: 'From Miami',
    key: 'miamiDistance',
    type: 'string',
  },
  {
    title: 'From the Airport',
    key: 'airportDistance',
    type: 'string',
  },
  {
    title: 'Rooms',
    key: 'numRooms',
    type: 'string',
  },
  {
    title: 'Room Categories',
    key: 'roomCategories',
    type: 'string',
  },
  {
    title: 'Swim-up Rooms',
    key: 'swimupPools',
    type: 'check',
  },
  {
    title: 'Private Pools',
    key: 'privatePools',
    type: 'check',
  },
  {
    title: 'Restaurants',
    key: 'resortRestaurants',
    type: 'string',
  },
  {
    title: 'Swim-up Bars',
    key: 'swimupBars',
    type: 'check',
  },
  {
    title: 'Off-Shore Island',
    key: 'offshoreIsland',
    type: 'check',
  },
  {
    title: 'Type of Beach',
    key: 'beachType',
    type: 'string',
  },
  {
    title: 'Pools',
    key: 'resortPool',
    type: 'string',
  },
  {
    title: 'Whirlpools',
    key: 'resortWhirlpools',
    type: 'string',
  },
  {
    title: 'Butler Service',
    key: 'butlerService',
    type: 'check',
  },
  {
    title: 'All Butler Service',
    key: 'allBService',
    type: 'check',
  },
  {
    title: 'Scuba Diving',
    key: 'scubaDiving',
    type: 'check',
  },
  {
    title: 'Watersports',
    key: 'waterSports',
    type: 'check',
  },
  {
    title: 'Waterskiing',
    key: 'waterSkiing',
    type: 'check',
  },
  {
    title: 'Golf',
    key: 'golf',
    type: 'check',
  },
  {
    title: <span>Red Lane<sup>®</sup> Spa</span>,
    key: 'redlane',
    type: 'check',
  },
  {
    title: 'Meeting Space',
    key: 'meetingSpace',
    type: 'check',
  },
  // {
  //   title: 'Accessibility',
  //   key: 'accessibility',
  //   type: 'link',
  //   arrowDirection: 'left',
  // },
];

const beachesOptions = [
  {
    title: 'Resort Name',
    key: 'resortName',
    type: 'string',
  },
  {
    title: 'Resort Location',
    key: 'resortLocation',
    type: 'string',
  },
  {
    title: 'From Miami',
    key: 'fromMiami',
    type: 'string',
  },
  {
    title: 'From the Airport',
    key: 'fromAirport',
    type: 'string',
  },
  {
    title: 'Rooms',
    key: 'rooms',
    type: 'string',
  },
  {
    title: 'Room Categories',
    key: 'roomCategories',
    type: 'string',
  },
  {
    title: 'Restaurants',
    key: 'restaurants',
    type: 'string',
  },
  {
    title: 'Bars',
    key: 'bars',
    type: 'string',
  },
  {
    title: 'Swim-up Bars',
    key: 'swimupBars',
    type: 'string',
  },
  {
    title: 'Length of Beach',
    key: 'lengthBeach',
    type: 'string',
  },
  {
    title: 'Pools',
    key: 'pools',
    type: 'string',
  },
  {
    title: 'Kiddie Pools',
    key: 'kiddiePools',
    type: 'string',
  },
  {
    title: 'Whirlpools',
    key: 'whirlpools',
    type: 'string',
  },
  {
    title: 'Waterpark',
    key: 'waterpark',
    type: 'check',
  },
  {
    title: 'Surf Simulator',
    key: 'surfSimulator',
    type: 'check',
  },
  {
    title: 'Butler Service',
    key: 'butlerService',
    type: 'check',
  },
  {
    title: 'Scuba Diving',
    key: 'scubaDiving',
    type: 'check',
  },
  {
    title: 'Watersports',
    key: 'watersports',
    type: 'check',
  },
  {
    title: 'Waterskiing',
    key: 'waterskiing',
    type: 'check',
  },
  {
    title: 'Kids Camp',
    key: 'kidsCamp',
    type: 'link',
    arrowDirection: 'right',
  },
  {
    title: 'Liquid Night Club',
    key: 'liquidNightClub',
    type: 'check',
  },
  {
    title: 'Xbox Play Lounge',
    key: 'xboxPlayLounge',
    type: 'check',
  },
  {
    title: 'Red Lane® Spa',
    key: 'redLaneSpa',
    type: 'check',
  },
  {
    title: 'Golf',
    key: 'golf',
    type: 'check',
  },
  {
    title: 'Meeting Space',
    key: 'meetingSpace',
    type: 'check',
  },
];

const options = isSandals ? sandalsOptions : beachesOptions;

export default options;



// WEBPACK FOOTER //
// ./js/json/step1/compare/options.js